import { useCallback, useEffect, useState } from "react";
import { listarCursos } from "../../../../services/cursosService";

export default function usePromocionCursos() {
  const [cursos, setCursos] = useState([]);
  const [cursosLoading, setCursosLoading] = useState(true);
  const [cursosError, setCursosError] = useState(null);

  const fetchCursos = useCallback(async () => {
    setCursosLoading(true);
    try {
      const data = await listarCursos();
      // Las variantes comerciales (ej. Reentrenamiento N1/N2) nunca tienen promocion propia;
      // solo se ofrecen los cursos oficiales/raiz para crear una promocion.
      const soloOficiales = (Array.isArray(data) ? data : []).filter((c) => !c.curso_oficial_id);
      setCursos(soloOficiales);
      setCursosError(null);
    } catch (err) {
      console.error(err);
      setCursosError(err.message || "No se pudo cargar la lista de cursos.");
    } finally {
      setCursosLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchCursos();
  }, [fetchCursos]);

  return {
    cursos,
    cursosLoading,
    cursosError,
    reloadCursos: fetchCursos,
  };
}
